export enum PentestType {
  AWSPentest = 0,
  AzurePentest = 1,
  NodeZero = 2,
  Phishing = 3,
  ExternalAttack = 4,
  ADPasswordAudit = 5,
  NetworkEnumeration = 6,
  K8sPentest = 7,
  InsiderThreatAttack = 8,
}

export namespace PentestType {
  export function mapFromApiValue(type: string): PentestType {
    const types: Record<string, PentestType> = {
      ['AWSPentest']: PentestType.AWSPentest,
      ['AzurePentest']: PentestType.AzurePentest,
      ['NodeZero']: PentestType.NodeZero,
      ['Phishing']: PentestType.Phishing,
      ['ExternalAttack']: PentestType.ExternalAttack,
      ['ADPasswordAudit']: PentestType.ADPasswordAudit,
      ['NetworkEnumeration']: PentestType.NetworkEnumeration,
      ['K8sPentest']: PentestType.K8sPentest,
      ['InsiderThreatAttack']: PentestType.InsiderThreatAttack,
    };
    return types[type];
  }

  export function name(status: PentestType): string {
    const names: Record<PentestType, string> = {
      [PentestType.AWSPentest]: 'dashboard.pentestTypes.awsPentest',
      [PentestType.AzurePentest]: 'dashboard.pentestTypes.azurePentest',
      [PentestType.NodeZero]: 'dashboard.pentestTypes.nodeZero',
      [PentestType.Phishing]: 'dashboard.pentestTypes.phishing',
      [PentestType.ExternalAttack]: 'dashboard.pentestTypes.externalAttack',
      [PentestType.ADPasswordAudit]: 'dashboard.pentestTypes.adPasswordAudit',
      [PentestType.NetworkEnumeration]: 'dashboard.pentestTypes.networkEnumeration',
      [PentestType.K8sPentest]: 'dashboard.pentestTypes.k8sPentest',
      [PentestType.InsiderThreatAttack]: 'dashboard.pentestTypes.insiderThreatAttack',
    };

    return names[status] || '--';
  }
}
